module.exports = __webpack_public_path__ + "img/core_five.e84ad0d6.png";